<template>
  <TopGradientBlockLayout>
    <div class="text-xl font-bold text-text leading-tight mb-12">{{ $t('title') }}</div>
    <div class="space-y-8">
      <NotificationsSettingsItem v-for="setting in notificationsSettings"
                                 :key="setting.id"
                                 :setting="setting"
                                 :title="settingTitle(setting.event)"
                                 :subtitle="settingSubtitle(setting.event)"
                                 @update="updateSetting(setting,$event)"

      />
    </div>
  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import BaseToggle from "@/components/UI/BaseToggle";
import NotificationsSettingsItem from "@/components/cabinet/ProfileSettings/Nofitications/NotificationsSettingsItem";
import {mapActions, mapState} from "vuex";

export default {
  name: "TheNotifications",
  components: {NotificationsSettingsItem, BaseToggle, TopGradientBlockLayout},
  data() {
    return {}
  },
  computed: {
    ...mapState('cabinet/user/notificationsSettings', ['notificationsSettings'])
  },
  methods: {
    ...mapActions('cabinet/user/notificationsSettings', ['fetchNotificationsSettings', 'updateNotificationSetting']),
    settingTitle(setting) {
      return this.$t(`notificationText.${setting}.title`)
    },
    settingSubtitle(setting) {
      return this.$t(`notificationText.${setting}.subtitle`)
    },
    updateSetting(setting, newValue) {
      let newSetting = {...setting, [newValue.name]: newValue.value}
      this.updateNotificationSetting(newSetting)
    }
  },
  async mounted() {
    await this.fetchNotificationsSettings();
  },
  i18n: {
    messages: {
      en: {
        title: 'Notifications',
        notificationText: {
          articles: {
            title: 'Useful articles about finance',
            subtitle: 'Increase your financial literacy with us! No more than one notice per week.'
          },
          blog: {
            title: 'MoneyKeeper New Features',
            subtitle: 'Let\'s talk about new sections, important updates and features - use our service even more efficiently!'
          },
          budget: {
            title: 'Budget',
            subtitle: 'On the first day of the month we will propose to create a budget for the next month.'
          },
          calendar: {
            title: 'Calendar',
            subtitle: 'Remind about the scheduled payment on the day of payment.'
          },
          finances: {
            title: 'Accounting',
            subtitle: 'Once a week we remind you to write down expenses and income. Try it! You can always turn it off 😊'
          },
          tickets: {
            title: 'Support Answers',
            subtitle: 'We will send a notification as soon as support responds to your request.'
          },
        }
      },
      ru: {
        title: 'Уведомления',
        notificationText: {
          articles: {
            title: 'Полезные статьи о финансах',
            subtitle: 'Повышайте финансовую грамотность с нами! Не больше одного уведомления в неделю.'
          },
          blog: {
            title: 'Новые возможности MoneyKeeper',
            subtitle: 'Расскажем о новых разделах, важных обновлениях и фишках — используйте наш сервис еще эффективнее!'
          },
          budget: {
            title: 'Бюджет',
            subtitle: 'В первый день месяца предложим создать бюджет на ближайщий месяц.'
          },
          calendar: {
            title: 'Календарь',
            subtitle: 'Напомним о запланированном платеже в день платежа.'
          },
          finances: {
            title: 'Учет',
            subtitle: 'Один раз в неделю напомним, что стоит записать расходы и доходы. Попробуйте! Всегда сможете отключить 😊'
          },
          tickets: {
            title: 'Ответы поддержки',
            subtitle: 'Отправим уведомление, как только поддержка ответит на ваше обращение.'
          },
        }
      }
    }
  }
}
</script>

<style scoped>

</style>